import { Flex } from '@chakra-ui/react';
import { SideMenuSettingsTrigger } from 'modules/Editor/components/SideMenuSettings/SideMenuSettingsTrigger';
import { AltTextMenu } from 'modules/Editor/components/Toolbar/AltTextMenu/AltTextMenu';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useWidget } from 'widgets/sdk';

export const MapWidgetToolbar = (): ReactElement => {
  const { widgetId } = useWidget();
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'mapChartToolbar' });

  return (
    <Flex align={'center'} gap={'2'}>
      <SideMenuSettingsTrigger>{t('editMap.label')}</SideMenuSettingsTrigger>
      <ToolbarDivider />
      <AltTextMenu widgetId={widgetId} />
    </Flex>
  );
};
